import L from "leaflet";
import { hostDefinitionOf, layerBounds } from "./host";
import type { SourceFactory } from "./types";

export const geojsonSource: SourceFactory = (entry, context) => {
  const definition = hostDefinitionOf(entry);

  if (definition === null || !definition.geojson) return null;

  const pane = context.paneFor(entry);
  const color = definition.color ?? "#2563eb";
  const layer = L.geoJSON(definition.geojson, {
    pane,
    style: () => ({ color, weight: 3, opacity: 0.9, fillColor: color, fillOpacity: 0.15, pane }),
    pointToLayer: (_feature, latlng) => L.circleMarker(latlng, { radius: 6, color, weight: 2, fillColor: color, fillOpacity: 0.9, pane })
  });

  return {
    entry,
    kind: "geojson",
    layer,
    pane,
    bounds: () => definition.fitBounds?.() ?? layerBounds(layer),
    features: null,
    info: null,
    legend: () => entry.legend,
    dispose: () => layer.remove()
  };
};
